module.exports = {
	"root": "findify-components--checkbox-facet",
	"expanded-list": "findify-components--checkbox-facet__expanded-list",
	"expandedList": "findify-components--checkbox-facet__expanded-list",
	"mobile": "findify-components--checkbox-facet__mobile",
	"item": "findify-components--checkbox-facet__item",
	"content": "findify-components--checkbox-facet__content",
	"search": "findify-components--checkbox-facet__search",
	"icon": "findify-components--checkbox-facet__icon",
	"input": "findify-components--checkbox-facet__input",
	"expand": "findify-components--checkbox-facet__expand"
};